import React from 'react';
import get from 'lodash/get';
import { PapiEditorText } from '@wix/da-papi-types';
import LegacyTextRenderer, { type LegacyTheme } from './LegacyTextRenderer';
import DOMPurify from 'isomorphic-dompurify';

export interface Props {
  textContent?: PapiEditorText;
  className?: string;
  emptyPlaceHolder?: string;
  legacyTheme?: LegacyTheme;
  // You can use this pretty freely as backend will send sanitisied data (from DAML)
  htmlExcerptLegacy?: boolean;
  // Polls are special and have html in their excerpt
  isPollWithHtmlExcerpt?: boolean;
  disableStylesForLegacy?: boolean; // We want to disable eclipse styles for certain legacy content to avoid conflicting with legacy css
}

const ExcerptRenderer = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      textContent,
      className,
      htmlExcerptLegacy,
      isPollWithHtmlExcerpt,
      legacyTheme,
      disableStylesForLegacy,
      emptyPlaceHolder = '',
    },
    ref
  ) => {
    if (!textContent) {
      return null;
    }

    const type = get(textContent, 'html.type');
    // not using the default value param because it should fall back for empty string, too
    const excerpt: string = get(textContent, 'excerpt') || emptyPlaceHolder;

    if (htmlExcerptLegacy && type === 'writer') {
      return (
        <LegacyTextRenderer
          className={className}
          html={excerpt}
          theme={legacyTheme}
          disableStyles={disableStylesForLegacy}
          ref={ref}
        />
      );
    }

    if (isPollWithHtmlExcerpt && type === 'draft' && excerpt.trim().length > 0) {
      return (
        <div
          className={className}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(excerpt, {
              FORCE_BODY: true,
              ADD_TAGS: ['iframe'],
            }),
          }}
          ref={ref}
        />
      );
    }

    return (
      <div className={className} ref={ref}>
        {excerpt}
      </div>
    );
  }
);
ExcerptRenderer.displayName = 'ExcerptRenderer';

export default ExcerptRenderer;
